import React from "react";

const RESIDENCE_PROOFS = [
  "Ration Card",
  "Passport",
  "Voter Card",
  "Driving Licence",
  "Aadhaar Card",
];

const ADMISSION_STEPS = [
  "Complete the enquiry and registration details at the school office.",
  "Submit student and parent documents for verification.",
  "Attend interaction/screening as scheduled by the admissions desk.",
  "Confirm admission with fee submission within the given timeline.",
];

const DEADLINE_ITEMS = [
  "Admissions are open for 2025-2026 from January 2025.",
  "Seats are allotted on a first-come, first-served basis after verification.",
  "Admission is confirmed only after fee receipt and approval from administration.",
];

function Admissions() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-10">
      <div className="mx-auto max-w-6xl space-y-6">
        <section className="rounded-3xl bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 p-8 text-white shadow-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-white">
            Admissions
          </p>
          <h1 className="mt-3 text-3xl font-semibold sm:text-4xl text-white">
            Join Rising Stars Public School
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-6 text-white sm:text-base">
            Admissions for 2025-2026 are open from January 2025 up Class 8.
            Complete the process early to secure your preferred seat.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-3">
            <div className="rounded-2xl border border-white/20 bg-white/10 p-4">
              <p className="text-xs uppercase tracking-[0.2em] text-white">
                Session
              </p>
              <p className="mt-2 text-xl font-semibold text-white">2025-2026</p>
            </div>
            <div className="rounded-2xl border border-white/20 bg-white/10 p-4">
              <p className="text-xs uppercase tracking-[0.2em] text-white">
                Classes
              </p>
              <p className="mt-2 text-xl font-semibold text-white">
                up to Class 8
              </p>
            </div>
            <div className="rounded-2xl border border-white/20 bg-white/10 p-4">
              <p className="text-xs uppercase tracking-[0.2em] text-white">
                Start Date
              </p>
              <p className="mt-2 text-xl font-semibold text-white">
                January 2025
              </p>
            </div>
          </div>
        </section>

        <section className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md">
            <h2 className="text-2xl font-semibold text-slate-900">
              Required Documents
            </h2>
            <p className="mt-2 text-sm leading-6 text-slate-600">
              Keep these documents ready while applying for admission.
            </p>

            <div className="mt-5 space-y-3 text-sm text-slate-800">
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
                Birth Certificate of the Student
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
                Identity Proof of Parents (Aadhaar Card)
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
                <p className="font-semibold text-slate-900">
                  Residence Proof (any one)
                </p>
                <ul className="mt-2 grid gap-1 text-slate-700 sm:grid-cols-2">
                  {RESIDENCE_PROOFS.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
                <p className="font-semibold text-slate-900">
                  Passport Size Photographs
                </p>
                <p className="mt-1 text-slate-700">3 copies for student</p>
                <p className="text-slate-700">
                  1 copy each for father and mother
                </p>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
                Transfer Certificate and Report Card from previous school
                (except Nursery/LKG/UKG/Class 1).
              </div>
            </div>
          </article>

          <div className="space-y-6">
            <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md">
              <h2 className="text-2xl font-semibold text-slate-900">
                Admission Process
              </h2>
              <ul className="mt-4 space-y-3 text-sm leading-6 text-slate-700">
                {ADMISSION_STEPS.map((step, index) => (
                  <li
                    key={step}
                    className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
                  >
                    <span className="mr-2 font-semibold text-blue-700">
                      {index + 1}.
                    </span>
                    {step}
                  </li>
                ))}
              </ul>
            </article>

            <article className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md">
              <h2 className="text-2xl font-semibold text-slate-900">
                Important Deadlines
              </h2>
              <ul className="mt-4 space-y-3 text-sm leading-6 text-slate-700">
                {DEADLINE_ITEMS.map((item) => (
                  <li
                    key={item}
                    className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </article>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Admissions;
